import styled from "@emotion/styled"
import { LogoIcon, LogoIconMobile } from "ui/icons"

import { ImageContainer, MainContainer, PositionVector, useIsDesktop } from "ui"
import { extractProperty } from "utils"

const StyledImageWrapper = styled.div`
  position: relative;
`

const StyledSvgWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 20px;
  left: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    top: 40px;
    left: 40px;
    svg {
      width: 195px;
      height: 55px;
    }
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    svg {
      width: 292px;
      height: 80px;
    }
  }
`

function PazomatBanner({ data }: { data: any }) {
  const isDesktop = useIsDesktop()
  const desktopImage = extractProperty(data, "desktopImage")
  const mobileImage = extractProperty(data, "mobileImage")

  return (
    <MainContainer rightGap={220} mediumRightGap={146}>
      <StyledImageWrapper>
        <StyledSvgWrapper>
          {isDesktop ? <LogoIcon /> : <LogoIconMobile />}
        </StyledSvgWrapper>
        <ImageContainer
          largeHeight={640}
          height={427}
          desktopUrl={desktopImage}
          mobileUrl={mobileImage}
          mobileHeight={480}
          mediumHeight={427}
          sm
        >
          <PositionVector
            pazomat={true}
            textOne={isDesktop ? "כניסה לאיזור האישי" : "כניסה"}
            textTwo={isDesktop ? "הרשמה לאתר פזומט" : "הרשמה"}
            linkOne={"https://service.pazomat.co.il/Login"}
            linkTwo={"/energy-and-industries/pazomat/sign-up"}
          />
        </ImageContainer>
      </StyledImageWrapper>
    </MainContainer>
  )
}

export default PazomatBanner
